import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {NgForOf} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {PartyHts10Dto, TemplateDto} from "../../shipper";
import {CountryCodeSelect} from "./country.select";



@Component({
    selector: "hts-list",
    standalone: true,
    imports: [
        NgForOf,
        FormsModule,
        CountryCodeSelect
    ],
    template: `
        <table class="table table-sm table-bordered table-striped m-0">
            <thead>
            <tr>
                <th style="width: 30%;">HTS</th>
                <th style="width: 350px;">Country</th>
                <th>
                    <button (click)="addHTS()" class="btn btn-sm btn-success"><i class="bi bi-plus-circle-fill"></i></button>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let h of hts">
                <td>
                    <input type="text" class="form-control form-control-sm" placeholder="HTS No."
                           [(ngModel)]="h.hts"
                           (blur)="htsTxtChange()"
                           [class.border-danger]="h.hts.length < 6"
                           [class.border-success]="h.hts.length >= 6"/>
                </td>
                <td style="width: 350px;">
                    
                    <country-select [includeCanadian]="true" [(selectedCountryCode)]="h.country"></country-select>
                    
                </td>
                <td>
                    
                    <button (click)="removeHTS(h)" class="btn btn-sm btn-danger"><i class="bi bi-dash-circle-fill"></i></button>
                    
                </td>
            </tr>
            </tbody>
        </table>
    `
})
export class HTSList implements OnInit, AfterViewInit{
    
    @Input()
    hts:Array<PartyHts10Dto> = [];
    
    @Input()
    template!:TemplateDto;

    @Output()
    htsChange:EventEmitter<Array<PartyHts10Dto>> = new EventEmitter<Array<PartyHts10Dto>>();

    @Input()
    country!:string;
    
    @Output()
    countryChange:EventEmitter<string> = new EventEmitter();
    
    
    ngOnInit(): void {
        this.hts = this.hts || [];
    }
    
    
    ngAfterViewInit(): void {
        if(this.hts.length == 0){
            //this.hts.push(<PartyHts10Dto> {hts:'', country:this.country });
        }
    }

    addHTS(){
        this.hts.push(<PartyHts10Dto> {hts:'', country:this.country });
        this.htsChange.emit(this.hts);
    }

    removeHTS(hts:PartyHts10Dto){
        this.hts = this.hts.filter((h) => h != hts);
        this.htsChange.emit(this.hts);
    }


    htsTxtChange(){
        this.hts = this.hts.map(h => <PartyHts10Dto>{hts: h.hts.trim(), country: h.country});
        this.htsChange.emit(this.hts);
    }


    countrySelected(hts:PartyHts10Dto, country:string){
        hts.country = country;

        this.htsChange.emit(this.hts);
    }
}

